<template>
    <div class="nevs-content">
        <NevsCard>
            <NevsTextField style="float: left;" :label="$LANG.Get('labels.filter') + ':'" :width="'300px'" v-model="sessionTypesData.filters.name"></NevsTextField>
            <NevsCheckbox style="float: left; margin-left: 15px;" :width="'auto'" :reserveHeights="true" v-model="sessionTypesData.filters.show_inactive" :label="$LANG.Get('labels.showInactiveSessionTypes')"></NevsCheckbox>
            <span style="float: right;"><NevsButton class="primary" @click="addSessionType"><i class="fa-solid fa-plus"></i> {{ $LANG.Get('buttons.addSessionType') }}</NevsButton></span>
            <div style="clear: both;"></div>

            <NevsTinyGrid :columns="gridColumns" :records="sessionTypesData.records" :actions="gridActions"
                          :empty-text="$LANG.Get('labels.noSessionTypes')" :is-inactive="(sessionType) => !sessionType.active"
                          @action="gridAction">
                <template #cell-color="{ record }">
                    <span class="session-type-color" :style="{backgroundColor: record.color}"></span>
                </template>
            </NevsTinyGrid>
        </NevsCard>
        <ModalEditSessionType :show="editSessionTypeModal.show" :session-type="editSessionTypeModal.sessionType" @done="editSessionTypeDone"></ModalEditSessionType>
    </div>
</template>

<script>

import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsTinyGrid from "@/components/nevs/NevsTinyGrid.vue";
import ModalEditSessionType from "@/components/modals/ModalEditSessionType.vue";

export default {
    name: "ModuleSessionTypes",
    components: {NevsTinyGrid, ModalEditSessionType, NevsCheckbox, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            sessionTypesData: {
                filters: {
                    name: '',
                    show_inactive: false
                },
                records: [],
                filterTimer: null
            },
            editSessionTypeModal: {
                show: false,
                sessionType: null
            }
        }
    },
    computed: {
        gridColumns() {
            return [
                {key: 'color', label: '', width: '30px'},
                {key: 'name', label: this.$LANG.Get('fields.name')},
                {key: 'capacity', label: this.$LANG.Get('fields.capacity'), align: 'right'}
            ];
        },
        gridActions() {
            return [
                {name: 'edit', icon: 'fa-solid fa-pen', tooltip: this.$LANG.Get('tooltips.edit')}
            ];
        }
    },
    watch: {
        'sessionTypesData.filters.name': {
            handler() {
                if (this.sessionTypesData.filterTimer !== null) {
                    clearTimeout(this.sessionTypesData.filterTimer);
                }
                let vm = this;
                this.sessionTypesData.filterTimer = setTimeout(function () {
                    vm.reloadSessionTypes();
                }, 500);
            },
            deep: true
        },
        'sessionTypesData.filters.show_inactive': {
            handler() {
                this.reloadSessionTypes();
            }
        }
    },
    methods: {
        gridAction(name, sessionType) {
            if (name === 'edit') {
                this.editSessionType(sessionType);
            }
        },
        addSessionType() {
            this.editSessionTypeModal.sessionType = null;
            this.editSessionTypeModal.show = true;
        },
        editSessionType(sessionType) {
            this.editSessionTypeModal.sessionType = sessionType;
            this.editSessionTypeModal.show = true;
        },
        editSessionTypeDone(success) {
            this.editSessionTypeModal.show = false;
            this.editSessionTypeModal.sessionType = null;
            if (success) {
                this.reloadSessionTypes();
            }
        },
        reloadSessionTypes() {
            let vm = this;
            let request = {
                filters: this.sessionTypesData.filters
            };
            this.$API.APICall('get', 'session-types', request, (data, success) => {
                if (success) {
                    vm.sessionTypesData.records = data.records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'training');
        this.$store.commit('selectSubMenu', 'sessionTypes');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.training'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.sessionTypes'),
                link: null
            }
        ]);
        this.reloadSessionTypes();
    }
}
</script>

<style scoped>
.session-type-color {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    vertical-align: middle;
}
</style>
